export default __webpack_public_path__ + "static/img1BO-5cf178bc436bc8a10ad2fd99f4fc8565.png";